<template>
    <span class="font-semibold text-sm pl-4">
        {{ text }}
    </span>

    <div class="flex items-center gap-3 font-semibold text-sm">
        <div class="flex items-center gap-1">
            <div class="time-box">{{ countdown.days }}</div><span>Hari</span>
        </div>
        <div class="flex items-center gap-1">
            <div class="time-box">{{ countdown.hours }}</div><span>Jam</span>
        </div>
        <div class="flex items-center gap-1">
            <div class="time-box">{{ countdown.minutes }}</div><span>Menit</span>
        </div>
        <div class="flex items-center gap-1">
            <div class="time-box">{{ countdown.seconds }}</div><span>Detik</span>
        </div>
    </div>
</template>

<script>
    export default {
    name: 'TicketCountdown',
    props: {
        countdown: {
            type: Object,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
    },
    }
</script>
